/**
 * Runtime Tailwind theme extension for browser builds (matches design tokens in Blade/CSS).
 */
export function setupTailwindWindowConfig() {
    if (typeof window === 'undefined') return;

    window.tailwind = window.tailwind || {};
    window.tailwind.config = {
        darkMode: 'class',
        theme: {
            extend: {
                colors: {
                    'czech-blue': '#11457E',
                    'pending-yellow': '#FDB022',
                    'pending-bg': '#FFFAEB',
                    'background-light': '#F8F9FA',
                    'dark-text': '#1A1A1A',
                },
                fontFamily: {
                    display: ['Public Sans', 'sans-serif'],
                },
                borderRadius: {
                    DEFAULT: '0.25rem',
                    lg: '0.5rem',
                    xl: '0.75rem',
                    '2xl': '1rem',
                },
            },
        },
    };
}
